import {
  ActivatedRouteSnapshot,
  DetachedRouteHandle,
  RouteReuseStrategy,
} from '@angular/router';
import { SequenceCardComponent } from '../sequence/sequence-card/sequence-card.component';
import { FlightSearchComponent } from '@calendar/flight-search/flight-search.component';

/**
 * If navigating from sequence to leg details, store sequence display so that it's state is
 * the same upon returning (specifically which duty period(s) are expanded).
 */
export class CustomReuseStrategy implements RouteReuseStrategy {
  storedHandles: { [key: string]: DetachedRouteHandle } = {};

  // Do we want to reuse this component (leaving component)?
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return (
      route.component === SequenceCardComponent ||
      route.component === FlightSearchComponent
    );
  }

  // Should we use a stored component?
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return (
      (route.component === SequenceCardComponent ||
        route.component === FlightSearchComponent) &&
      !!this.storedHandles[route.url.join('/')]
    );
  }

  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    return curr.routeConfig === future.routeConfig;
  }

  store(
    route: ActivatedRouteSnapshot,
    handle: DetachedRouteHandle | null
  ): void {
    if (
      handle &&
      (route.component === SequenceCardComponent ||
        route.component === FlightSearchComponent)
    ) {
      this.storedHandles[route.url.join('/')] = handle;
    }
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    if (
      route.component === SequenceCardComponent ||
      route.component === FlightSearchComponent
    ) {
      return this.storedHandles[route.url.join('/')];
    }

    return null;
  }
}
